import SideModal from "components/SideModal";
import { useToast } from "contexts/ToastContext";
import { ChangeEvent, useState } from "react";
import { addAppealCouncilLitigationAttendance } from "services/prosecutorDecipilineService";
import { CouncilLitigation } from "types";
import { LoadingIcon } from "utils/constant";
import "../../complaintRequest/styles/AddEvidenceModal.css";
import { useTranslation } from "contexts/i18nContext";

interface FeedbackModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  litigationData: CouncilLitigation;
  onRefresh: any;
}

export default function AddCouncilMeetingAttendance({
  isOpen,
  setIsOpen,
  litigationData,
  onRefresh,
}: FeedbackModalProps) {
  const { t } = useTranslation();
  const { showToast } = useToast();
  // const [query, setQuery] = useState("");
  // const [showDropdown, setShowDropdown] = useState(false);
  // const [employeesData, setEmployeesData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  // const [error, setError] = useState<string | null>(null);
  // const [success, setSuccess] = useState(false);

  const [formState, setFormState] = useState({
    council_member: "",
    was_present: "true",
    selected_employee: null as any,
    remark: "",
  });

  // useEffect(() => {
  //   if (!query) return;

  //   const loadEmployees = async () => {
  //     setLoading(true);

  //     try {
  //       const data = await fetchEmployees(query);
  //       // setEmployeesData(data);
  //       // setError("");
  //     } catch (err) {
  //       // setError("Failed to load prosecutors.");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   loadEmployees();
  // }, [query]);

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  // const handleAccusedProsecutorSelect = (employee: any, name: string) => {
  //   setFormState((prevState) => ({
  //     ...prevState,
  //     [name]: employee,
  //     council_member:
  //       `${employee?.english_first_name || ""} ${
  //         employee?.english_middle_name || ""
  //       } ${employee?.english_last_name || ""}`.trim() || "Unknown",
  //   }));
  //   setQuery("");
  //   // setShowDropdown(false);
  // };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!litigationData) return;

    setLoading(true);
    // setError(null);
    // setSuccess(false);

    const data = {
      ...formState,
      verdict: litigationData?.id || "",
    };

    try {
      await addAppealCouncilLitigationAttendance(data);

      onRefresh();
      setIsOpen(false);
      showToast(t("successfullyCreated"), "success");
      // setSuccess(true);
      setFormState({
        council_member: "",
        was_present: "true",
        selected_employee: null,
        remark: "",
      });
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast(t("submissionError"), "error");
      // setError(
      //   err?.response?.data?.message || err.message || "Something went wrong."
      // );
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <SideModal isOpen={isOpen} setIsOpen={setIsOpen} title={t("addAttendance")}>
      <form onSubmit={handleSubmit} className="evidence-form">
        <section className="evidence-section">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t("member")}
            </label>
            <input
              required
              name="council_member"
              value={formState.council_member}
              onChange={handleChange}
              placeholder={t("detailsHere")}
              className="w-full border bg-gray-100 rounded-md p-2 text-sm"
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t("present")}
            </label>
            <select
              required
              className="w-full border bg-gray-100 rounded-md p-2 text-sm"
              name="was_present"
              value={formState.was_present}
              onChange={handleChange}
            >
              <option value={"true"}>{t("yes")}</option>
              <option value={"false"}>{t("no")}</option>
            </select>
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t("remark")}
            </label>
            <textarea
              required
              rows={7}
              name="remark"
              value={formState.remark}
              onChange={handleChange}
              placeholder={t("detailsHere")}
              className="w-full border bg-gray-100 rounded-md p-2 text-sm"
            />
          </div>
        </section>

        <button
          type="submit"
          className="bg-black w-full text-white px-6 py-2 rounded-md hover:bg-gray-800"
          disabled={loading}
        >
          {loading ? (
            <div className="flex items-center justify-center">
              {LoadingIcon}
              {t("submitting")}...
            </div>
          ) : (
            t("addAttendance")
          )}
        </button>
      </form>
    </SideModal>
  );
}
